export default __webpack_public_path__ + "static/media/Cabin-Variable.68985814.ttf";